class NestMoney {
  constructor() {}

  /**
   * Format the incoming backend money type into currency type;
   * Return 0,00 if the incoming backend money is EUR 0,00.
   * For example:
   *    from EUR 23.50 to 23,50
   *    from EUR 148.75 to 148,75
   *    from EUR 1150.36 to 1.150,36
   */
  static formatCurrencyForFE(price) {
    if (price && price != "EUR 0.00") {
      let priceArray = price.split(" ");
      let currency = priceArray[0];
      let locale = "it-IT";
      let priceV2 = priceArray[1].replace(/,/g, ".");
      let amount = Number(priceV2).toLocaleString(locale, {
        style: "currency",
        currency: currency
      });
      return amount.substring(0, amount.length - 2);
    } else {
      return "0,00";
    }
  }

  /**
   * Format the incoming number currency type into string currency type for fe;
   * Return 0,00 if the incoming value is null or 0.
   * For example:
   *    from (number) 23.50 to 23,50
   *    from (number) 148.75 to 148,75
   *    from (number) 1150.36 to 1.150,36
   */
  static formatCurrencyAmountForFE(price) {
    if (price && (price != "0.0" || price != "0.00")) {
      let currency = "EUR";
      let locale = "it-IT";
      let amount = Number(price).toLocaleString(locale, {
        style: "currency",
        currency: currency
      });
      return amount.substring(0, amount.length - 2);
    } else {
      return "0,00";
    }
  }

  /**
   * Format the FE formatted currency amount into operational number type;
   * Return 0.00 if the incoming value is null or empty.
   * For example:
   *    from 23,50 to (number) 23.50
   *    from 148,75 to (number) 148.75
   *    from 1.150,36 to (number) 1150.36
   */
  static formatCurrencyAmountForOP(price) {
    if (price) {
      let priceV1 = price.replace(/\./g, "");
      let priceV2 = priceV1.replace(/,/g, ".");
      return Number(priceV2);
    } else {
      return 0.0;
    }
  }

  /**
   * Format the inputted price into backend money type;
   * For example:
   *    from 23,50 to EUR 23.50
   *    from 148,75 to EUR 148.75
   *    from 1.150,36 to EUR 1150.36
   */
  static formatCurrencyForBE(price) {
    if (price) {
      let priceV1 = price.replace(/\./g, "");
      let priceV2 = priceV1.replace(/,/g, ".");
      return "EUR".concat(" ").concat(priceV2);
    } else {
      return null;
    }
  }

  /**
   * Format price for operational purpose.
   * For example:
   *    from EUR 23.50 to 23.50
   *    from EUR 148.75 to 148.75
   *    from EUR 1150.36 to 1150.36
   */
  static formatCurrencyForOP(price) {
    if (price) {
      let priceArray = price.split(" ");
      let amount = Number.parseFloat(priceArray[1]);
      return amount.toFixed(2);
    } else {
      return "0.00";
    }
  }
}

export default NestMoney;
